import PropTypes from 'prop-types';

const CardHeader = ({ left, children, right }) => {
    return (
        <div className="flex flex-wrap md:flex-nowrap md:flex-row justify-between items-center bg-white border border-slate-400 rounded-lg shadow-md shadow-slate-500 p-2 md:p-3 gap-2">
            <div> {left} </div>
            <div> {children} </div>
            <div> {right} </div>
        </div>
    );
};

export default CardHeader;

CardHeader.propTypes = {
    left: PropTypes.node,
    right: PropTypes.node,
};